import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom"
import { Provider } from 'react-redux';
import store from './Redux/Store';
import { CSSReset, ChakraProvider } from '@chakra-ui/react';
import { SpeedInsights } from "@vercel/speed-insights/react"
import { Analytics } from "@vercel/analytics/react"

import { ModalToastProvider } from './context/GlobalModalToast';

import theme from './theme';

// --- Secure Session Isolation Guard ---
// Enforce session isolation for ALL users. If the browser is closed
// and sessionStorage dies, force a complete logout to prevent stolen sessions.
if (localStorage.getItem("user") && !sessionStorage.getItem("isSsoSession")) {
  // No active session flag found — force logout
  localStorage.removeItem("user");
  sessionStorage.clear();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ChakraProvider theme={theme}>
      <ModalToastProvider>
        <BrowserRouter>
          <CSSReset/>
          <App />
          <Analytics />
          <SpeedInsights />
        </BrowserRouter>
      </ModalToastProvider>
    </ChakraProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
